import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ADMIN_API_ENDPOINTS } from "service/apiUrl";
import { API } from "service/Interceptor";

const initialState = {
  users: [],
  filters: {
    fromDate: "",
    toDate: "",
    userType: "",
    status: "",
  },
  totalCount: null,
  isUsersLoading: false,
  hasError: false,
  isExporting: false,
};

export const getAllUsers = createAsyncThunk(
  "get-all-users",
  async ({ pageSelected, search, filters }, { rejectWithValue }) => {
    try {
      const { fromDate, toDate, userType ,categoryIds, isActive} = filters || {};
      //  const query = new URLSearchParams({
      //   search: search || "",
      //   export: "false",
      //   pageNo: String(pageSelected || 1),
      //   perPage: "10",
      //   ...Object.fromEntries(
      //     Object.entries(rest).filter(([_, v]) => v !== undefined && v !== "")
      //   ),
      // });

      const queryParams = new URLSearchParams({
        search: search || "",
        export: "false",
        pageNo: pageSelected,
        perPage: 10,
      });

      if (fromDate) queryParams.append("fromDate", fromDate);
      if (toDate) queryParams.append("toDate", toDate);
      if (isActive) queryParams.append("isActive", isActive);
      if (userType) queryParams.append("userType", userType);
      if (categoryIds) queryParams.append("categoryIds", categoryIds);

      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.USERS}?${queryParams.toString()}`
      );
      // const res = await API.get(
      //   `${ADMIN_API_ENDPOINTS.USERS}?search=${
      //     search || ""
      //   }&export=false&pageNo=${pageSelected}&perPage=10`
      // );
      return {
        data: res?.data?.data?.results,
        totalRecord: res?.data?.data?.totalRecord,
      };
    } catch (error) {
      console.log("error", error);
      // return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const handleUserStatus = createAsyncThunk(
  "update-user-status",
  async (payload) => {
    try {
      await API.post(ADMIN_API_ENDPOINTS.USER_STATUS, {
        id: payload?.userId,
        status: payload?.isSuspended,
        message: payload?.message,
      });
      return {
        userId: payload?.userId,
        reportMessage: payload.message,
      };
    } catch (error) {
      console.log(error);
    }
  }
);

export const exportUsers = createAsyncThunk("export-user", async (payload) => {
  try {
    const res = await API.get(`${ADMIN_API_ENDPOINTS.USERS}?export=true`, {
      responseType: "blob",
    });
    return res;
  } catch (error) {
    console.log("error", error);
  }
});
export const profileIncompleteMail = createAsyncThunk("profile-incomplete-mail", async (id) => {
  try {
    const res = await API.post(`${ADMIN_API_ENDPOINTS.USERS}/${id}/${ADMIN_API_ENDPOINTS.PROFILE_INCOMPLETE}`,{});
    return res;
  } catch (error) {
    console.log("error", error);
  }
});

export const userMangementSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------GET ALL USERS------------------
      .addCase(getAllUsers.pending, (state, action) => {
        state.isUsersLoading = true;
        state.hasError = false;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.isUsersLoading = false;
        state.hasError = true;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.isUsersLoading = false;
        state.hasError = false;
        state.users = action.payload?.data;
        state.totalCount = action.payload?.totalRecord;
      })
      //--------------------Toggle Status------------------
      .addCase(handleUserStatus.fulfilled, (state, action) => {
        const index = state.users.findIndex(
          (row) => row.id === action.payload?.userId
        );
        state.users[index].isSuspended = !state.users[index].isSuspended;
        state.users[index].suspensionReason = action.payload?.reportMessage;
      })
      // --------------------Exporting Users------------------
      .addCase(exportUsers.pending, (state, action) => {
        state.isExporting = true;
      })
      .addCase(exportUsers.fulfilled, (state, action) => {
        state.isExporting = false;
      })
      .addCase(exportUsers.rejected, (state, action) => {
        state.isExporting = false;
      });
  },
});

export const { setFilters } = userMangementSlice.actions;
export default userMangementSlice.reducer;
